export * from "./backgroundMaterial";

// async-loaded shaders

// backgroundMaterial
export * from "../../ShadersWGSL/background.vertex";
export * from "../../ShadersWGSL/background.fragment";
export * from "../../Shaders/background.vertex";
export * from "../../Shaders/background.fragment";
